import {publicHolidays} from './publicHolidays';

export const isFreeDay = (pickupDate: string): boolean =>
    publicHolidays(new Date(pickupDate).getFullYear()).includes(pickupDate) ||
    new Date(pickupDate).getDay() === 6 ||
    new Date(pickupDate).getDay() === 0;
